'use strict';

function getCurrentScriptPath() {
    var currentScript;
    var scripts;
    var scriptUrl;

    if (typeof document === 'undefined') {
        return undefined; // eslint-disable-line no-undefined
    }

    currentScript = document.currentScript;

    // Deal with IE 11
    if (!currentScript) {
        scripts = document.getElementsByTagName('script');
        currentScript = scripts[scripts.length - 1];
    }

    if (!currentScript || !currentScript.src) {
        return undefined; // eslint-disable-line no-undefined
    }

    scriptUrl = currentScript.src;
    return scriptUrl.slice(0, scriptUrl.lastIndexOf('/') + 1);
}

module.exports = getCurrentScriptPath;
